import { Exclude, Expose, Type } from "class-transformer"
import { Address } from "../address/address"
import { FieldDescriptor, FieldTypeEnum } from "../field-descriptor"
import ActivityHistoryLog from "./activity-history-log"

@Exclude()
class AddressExportLog extends ActivityHistoryLog {

    @Expose()
    @Type(() => Address)
    public address: Address | null = null

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.name"
    })
    public get name() {
      return this.address.name
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.country",
      columnWidth: "100"
    })
    public get country() {
      return this.address.country.name
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.zip_code"
    })
    public get zipcode() {
      return this.address.zipcode
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.city"
    })
    public get city() {
      return this.address.city
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.street"
    })
    public get street() {
      return this.address.street
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.phone"
    })
    public get phone() {
      return this.address.phone
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.email"
    })
    public get email() {
      return this.address.email
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.mobile"
    })
    public get mobile() {
      return this.address.mobile
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.contact"
    })
    public get contact() {
      return this.address.contact
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.comment"
    })
    public get comment() {
      return this.address.comment
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.fax"
    })
    public get fax() {
      return this.address.fax
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.TEXT,
      fieldPrettyName: "entity.address.own_code"
    })
    public get ownCode() {
      return this.address.ownCode
    }

    @FieldDescriptor({
      fieldType: FieldTypeEnum.BOOLEAN,
      fieldPrettyName: "entity.address.pickup"
    })
    public get pickupActive() {
      return this.address.pickupActive
    }


    public static exportUrl: string | null = "addressExportLog/export/csv"

}

export default AddressExportLog
